import React, { useEffect, useState } from "react";
import Box from "@mui/material/Box";
import Tab from "@mui/material/Tab";
import TabContext from "@mui/lab/TabContext";
import TabList from "@mui/lab/TabList";
import TabPanel from "@mui/lab/TabPanel";
import { Typography, Button } from "@mui/material";
import person from "../../Components/assets/images/profilePicture.png";
import {
  GroupDetailWithParticipants,
  GroupUserPayment,
  BaseUrl,
  getPaymentbyDate,
} from "../../services/Url";
import { Link, useParams } from "react-router-dom";
import moment from "moment";
import { post } from "../../services/Service";

export default function Payment() {
  const [value, setValue] = useState();
  const [date, setDate] = useState([]);
  const [pot, setPot] = useState([]);
  const [isloading, setIsloading] = useState(true);
  const [payment, setPayment] = useState([]);
  const [participant, setparticipant] = useState([]);
  const [cstmkey, setKey] = useState(0);
  const [group, setGroup] = useState({});

  const params = useParams();
  const singleDetail = async () => {
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + GroupUserPayment + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then(async (res) => {
        const responseData = await res.json();
        setDate(responseData.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  };
  const singleDetaildata = async () => {
    let token = localStorage.getItem("token");
    let CompleteUrl = BaseUrl + GroupDetailWithParticipants + `/${params.id}`;
    await fetch(CompleteUrl, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        "x-access-token": token,
      },
    })
      .then(async (res) => {
        const responseData = await res.json();
        setPot(responseData.data.pot);
        setparticipant(responseData.data.participant);
        setGroup(responseData.data.group[0])
      })
      .catch((err) => {
        console.log(err);
      });
  };

  let body = JSON.stringify({
    group_Id: params.id,
    date: value,
  });

  useEffect(() => {
    post(getPaymentbyDate, body, setPayment, setIsloading);
  }, [value]);

  useEffect(() => {
    singleDetail();
    singleDetaildata();
  }, []);

  let matchedObjects = pot?.map((obj) => {
      let matchingObj = participant.find(
        (bbObj) => bbObj._id === obj.participants
      );
      if (matchingObj) {
        return { ...obj, ...matchingObj };
      } else {
        return null;
      }
    })
    .filter((obj) => obj !== null);

  let matchedObject = payment
    .map((obj) => {
      let matchingObj = matchedObjects.find(
        (bbObj) => bbObj.participants === obj.participants
      );
      if (matchingObj) {
        return { ...obj, ...matchingObj };
      } else {
        return null;
      }
    })
    .filter((obj) => obj !== null);


  const handleChange = (event, newValue) => {
    group?.frequency_payment === "Monthly" ? setValue(newValue): setValue(newValue)
  };


  const itemHandler = (item, i) => {
    if(group?.frequency_payment === "Monthly"){
      setValue(item);
      setKey(i)
    }else{
      setValue(moment(item).format("YYYY-MM-DD"));
       setKey(i)
  }
}

  return (
    <>
      <ul
        style={{
          padding: 10,
          display: "flex",
        }}
      >
        {date?.map((item, i) => (
          <li
            className={cstmkey === i ? "date-list active" :"date-list"}
            style={{
              marginTop: "10px",
              marginRight: "50px",
              cursor: "pointer",
            }}
            onClick={() => itemHandler(item, i)}
            key={i}
          >
            
            <b>{group?.frequency_payment === "Monthly" ? item : moment(item).format("YYYY-MM-DD")}</b>
            
          </li>
        ))}
      </ul>

      <ul>
        {matchedObject?.length > 0
          ? matchedObject?.map((items, i) => (
              <li key={i}>
                 <Link key={i} className="partItem_wpr" to={`/userdetail/${items._id}`}>
                <p>
                  <img
                    src={items.profile_picture ? `https://api-staging.pardnerpal.co.uk/api/uploads/profile/${items.profile_picture}`:person}
                    alt="img"
                    style={{
                      width: "50px",
                      height: "50px",
                      marginRight: "10px",
                      borderRadius: "50%",
                      backgroundRepeat: "no-repeat",
                      backgroundPosition: "center center",
                      backgroundSize: " cover",
                    }}
                  />
                  {items.first_name} {items.last_name}, Amount -{" "}
                  {items.payment_amount} , Payment Date -{" "}
                  {moment(items.payment_date).format("ll")}
                </p>
                <hr></hr>
                </Link>
              </li>
            ))
          : <Typography className="fz-18 fw-bold text-center" >No Payment found </Typography >}
      </ul>
    </>
  );
}

